import { createTheme } from "@mui/material/styles";

const globaltheme = createTheme({
  palette: {
    primary: {
      main: "#00A8A9",
      contrastText: "#FFFFFF",
    },
  secondary: {
      main: "#ED6F2D",
      contrastText: "#FFFFFF",
    },
  },
  spacing: 8,
  typography: {
    fontFamily: '"Kanit", sans-serif',
    h1: {
      fontSize: "1.75rem",
      fontWeight: 600,
      color: "#00A8A9",
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#000000",
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: 500,
      color: "#000000",
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 500,
      color: "#000000",
      marginBottom: "0.5rem",
    },
    body1: {
      fontSize: "1rem",
      color: "#000000",
    },
    body2: {
      fontSize: "0.875rem",
      color: "#B6B6B6",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Kanit", sans-serif',
        },
        ".MuiDataGrid-columnHeader": {
          backgroundColor: "#00A8A9 !important",
          color: "#FFFFFF !important",
          fontWeight: "bold !important",
          fontSize: "0.875rem !important",
        },
        ".MuiDataGrid-columnHeaderTitle": {
          fontWeight: "bold !important",
          color: "#FFFFFF !important",
        },
        ".MuiDataGrid-columnSeparator": {
          color: "#FFFFFF !important",
        },
        ".MuiDataGrid-sortIcon": {
          color: "#FFFFFF !important",
        },
        ".MuiDataGrid-menuIconButton": {
          color: "#FFFFFF !important",
        },
        ".MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer .MuiButtonBase-root": {
          backgroundColor: "transparent !important",
          color: "#FFFFFF !important",
        },
        ".secondary .MuiTableCell-head": {
          backgroundColor: "#EEEEEE !important",
          color: "#000000 !important",
          fontWeight: "bold !important",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#00A8A9",
          color: "#FFFFFF",
          fontWeight: "bold",
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#000000",
          "&:hover": {
            backgroundColor: "rgba(0, 168, 169, 0.5)",
            color: "#ffffff",
          },
          "&.Mui-selected": {
            backgroundColor: "#00A8A9",
            color: "#ffffff",
          },
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          "& .MuiToggleButton-root": {},
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#00A8A9",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#00A8A9",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: "#00A8A9",
          },
          "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#00A8A9",
          },
        },
        track: {
          backgroundColor: "#BDBDBD",
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00A8A9",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00A8A9",
          },
        },
        notchedOutline: {
          "&.Mui-focused": {
            borderColor: "#00A8A9",
          },
          "&:hover": {
            borderColor: "#00A8A9",
          },
          borderColor: "#B6B6B6",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#B6B6B6",
            },
            "&:hover fieldset": {
              borderColor: "#00A8A9",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#00A8A9",
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00A8A9",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00A8A9",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#B6B6B6",
          },
        },
      },
    },
  },
});

export default globaltheme;
